import React from 'react'

const TabTitleH2 = ({children}) => {
  return (
    <h2 className='my-4 w-100 fs-2 '>{children}</h2>
  )
}

export default TabTitleH2